// extracted by mini-css-extract-plugin
module.exports = {"loader-aligment":"styles_loader-aligment__30EEL","custom-layout":"styles_custom-layout__3Cqyi"};